export const checkIsPath = path => {
  return window.location.pathname === path
}
